import { Link } from 'react-router-dom';

import { ComponentProps, MouseEvent } from 'react';

import { useRouteChange } from '@/hooks/useRouteChangeHandler';

export type RouteChangeLinkProps = Omit<ComponentProps<typeof Link>, 'to'> & {
  href: string;
};

export function RouteChangeLink({
  onClick,
  href,
  ...props
}: RouteChangeLinkProps) {
  const { startRouteChange } = useRouteChange();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Check if user is opening in new tab/window
    const isNewTab = e.metaKey || e.ctrlKey || e.button === 1 || e.shiftKey;

    // Don't trigger loading for same-page anchors or external links
    const isAnchor = href.startsWith('#');
    const isExternal = href.startsWith('http');
    const isSamePage = href === window.location.pathname;

    // Only start route change if it's a normal click (not opening in new tab)
    if (!isAnchor && !isExternal && !isSamePage && !isNewTab) {
      startRouteChange();
    }

    // Call original onClick if provided
    if (onClick) {
      onClick(e);
    }
  };

  return <Link {...props} to={href} onClick={handleClick} />;
}
